import { render, staticRenderFns } from "./client-timeline.vue?vue&type=template&id=c06c1d76"
import script from "./client-timeline.vue?vue&type=script&lang=js"
export * from "./client-timeline.vue?vue&type=script&lang=js"
import style0 from "./client-timeline.vue?vue&type=style&index=0&id=c06c1d76&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports